<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">Add Javascript snippet</h3>
            </div>
        </div>
        <!-- Second Row of Posts -->
        <d-row>
            <d-col lg="12">
                <d-card >
                    <d-card-header class="border-bottom">
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-network' }">2. Connect networks</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-intergration' }">3. Connect integrations</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'snippet' }"><u>4. Place Ivanhoe.io tag</u></d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">5. Choose direct or cloaked links</h6>
                            </d-col>
                            <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">6. Ready to start</h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body>
                        <d-row>
                            <d-col cols="12" class="mt-5 text-center">
                                <h4 class="font-weight-bold">Add tag to {{ website.domain }}</h4>
                                <p>Place this tag inside your &lt;header&gt;&lt;/header&gt; on {{ website.domain }}. Please make sure that the tag is loaded on every page of your website</p>
                            </d-col>
                            <d-col lg="12" md="12" sm="12">
                                <d-row class="script-row d-flex justify-content-center">
                                    <d-col cols="12" md="6" lg="7" xl="6">
                                        <d-form-text tag="h6" class="mb-3 script-tag add">
                                            {{ tag }}
                                        </d-form-text>
                                    </d-col>
                                    <d-col cols="12" md="4" lg="3" xl="3">
                                        <button v-clipboard="tag" @click="showSuccess" class="btn btn-success btn-sm">Copy to Clipboard</button>
                                    </d-col>
                                </d-row>
                            </d-col>
                        </d-row>
                    </d-card-body>
                    <d-card-footer>
                        <d-row>
                            <d-col class="d-flex justify-content-start">
                                <d-link tag="button" :to="{ name: 'add-intergration' }" class="btn btn-secondary">Previous step</d-link>
                            </d-col>
                            <d-col class="d-flex justify-content-end">
                                <d-link tag="button" :to="{ name: 'affiliate-link', params: { id: websiteId } }" class="btn btn-success">Next step</d-link>
                            </d-col>
                        </d-row>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
    import notification from '@/mixins/notification';
    import { WebsiteService } from '@/main';

    export default {
        mixins: [notification],

        data() {
            return {
                websiteId: this.$route.params.id,
                website: [],
                tag: '<script type="text/javascript" src="https://ivanhoe.io/iv.js">' + '<' + '/script>',
                percent: 56,
                selected: 'euro',
            };
        },

        methods: {
            showSuccess() {
                this.showNotification('success', 'Alert', 'Copied to clipboard!')
            },

            async getWebsite() {
                this.website = await WebsiteService.getById(this.$route.params.id)
            }
        },

        created() {
            this.getWebsite()
        }
    };
</script>
